import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getIndividualEmployeeYearlyAttendanceList: (state) => state.items,
  getIndividualEmployeeYearlyAttendanceListDate: (state) => state.filter.date,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
